import { useCurrentOverlay } from "shared/context/overlay/OverlayIDContext"
import { useEvent } from "shared/lib/useEvent"

import { useProjectGaebExport } from "entities/projects/model/useProjectGaebExport"

import {
  ProjectGaebExportFormData,
  ProjectGaebOverlayModel
} from "../ProjectGaebOverlay"
import { ProjectGaebOverlayConnectorProps } from "../ProjectGaebOverlayConnector"

export function useProjectGaebOverlayModel({
  payload: { projectID, isShareID }
}: ProjectGaebOverlayConnectorProps): ProjectGaebOverlayModel {
  const { closeOverlay } = useCurrentOverlay()
  const { exportProject } = useProjectGaebExport(projectID, isShareID)

  const handleSubmit = useEvent(({ phase }: ProjectGaebExportFormData) => {
    exportProject({ selectedOption: phase })
    closeOverlay()
  })

  return {
    onSubmit: handleSubmit,
    onCancel: closeOverlay
  }
}
